export default function CSAnimatedLogo() {
  return (
    <div className="flex flex-col leading-none">
      <div className="items-baseline">
        <span className="font-display italic font-bold text-3xl md:text-4xl tracking-tight text-cs-blue">
          c<span className="relative inline-block">ı<span className="absolute bg-red-600" style={{ top: '0.08em', left: '135%', transform: 'translateX(-50%)', width: '0.14em', height: '0.14em' }} /></span>rcuit<span className="text-cs-blue">-</span><span className="text-red-600">slot</span>
        </span>
      </div>
      <div className="text-sm text-gray-500 mt-1">Le circuit en Famille</div>
    </div>
  );
}